'use strict';

const _ = require('underscore');
const Base = require('components/Platform/PlatformCardExperience/Steps/BaseAnimation/BaseAnimation');

require('./Authorization.less');

const Selectors = {
    el: '.PlatformCardExperienceAuthorizationStep',
    svgItem: '.PlatformCardExperienceIconWrapper-iconImage'
};

const BindFunctions = [
    'setPaths'
];

module.exports = Base.extend({

    el: Selectors.el,

    initialize: function (options = {}) {
        Base.prototype.initialize.call(this, options);
        _.bindAll(this, BindFunctions);

        this.$svgItems = this.$(Selectors.svgItem);

        this.setPaths();
    },

    setPaths: function () {
        this.$svgItems.each((id, svg) => {
            const $svg = $(svg);

            $svg.find('path').each((i, path) => {
                const lenPath = path.getTotalLength();
                const $path = $(path);

                $path.css({
                    'stroke-dasharray': lenPath,
                    'stroke-dashoffset': lenPath
                });
            });
        });
    }
});
